<template>
  <div class="card-form">
    <b-card>
      <page-main
        :tableData="tableData"
        :tablePage="page"
        :loading="loading"
        @reload="reload"
      >
        <page-header
          ref="header"
          slot="header"
          @query="getData"
          @reset="resetPage"
          @openAddPage="openAddPage"
        />
        <pagination
          size="mini"
          align="right"
          slot="pager"
          :current-page="page.curPage"
          :page-size="page.pageSize"
          :page-total="page.pageTotal"
          @change="handlePaginationChange"
        />
      </page-main>
    </b-card>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import store from '../../store'
export default {
  components: {
    PageHeader,
    PageMain,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  computed: {
    selected() {
      return store.state.selected
    },
  },
  watch: {
    selected() {
      this.getData()
    },
  },
  methods: {
    getData(form) {
      if (!this.selected || !this.selected.categoryCode) return
      this.loading = true
      this.$api
        .masterYarnListApi({
          categoryCode: this.selected.categoryCode,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openAddPage() {
      let params = {categoryCode: this.selected.categoryCode}
      let pageType = 'add'
      this.$router.push({
        name: 'master-yarn-detail',
        params: {...params, pageType},
      })
    },
  },
}
</script>
